"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var IntegrationToFeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/IntegrationToFeatureFlag/IntegrationToFeatureFlag"));
var Platforms_1 = require("./Platforms");
var Platforms_2 = __importDefault(require("./Platforms"));
var PlansOrder_1 = __importDefault(require("@CommonFrontendBackend/Utils/PlansOrder"));
var IntegrationService = (function () {
    function IntegrationService(invoke, account, integrationFocusCreator, $log, usingFeature, upsellerService, state) {
        var _this = this;
        this.account = account;
        this.integrationFocusCreator = integrationFocusCreator;
        this.$log = $log;
        this.usingFeature = usingFeature;
        this.upsellerService = upsellerService;
        this.state = state;
        this.usingAnalyticsIntegration = function () {
            return _this.isEnabled("mixPanel") || _this.isEnabled("googleAnalytics") || _this.isEnabled("heapAnalytics");
        };
        this.integrationPlatforms = invoke(Platforms_2.default);
    }
    IntegrationService.prototype.isEnabled = function (integrationInternalName) {
        var integrationSettings = this.account.integrations[integrationInternalName];
        return integrationSettings && integrationSettings.enabled;
    };
    IntegrationService.prototype.getIntegrations = function () {
        return this.integrationPlatforms.filter(function (integration) {
            if (!integration.hidden) {
                return integration;
            }
        });
    };
    IntegrationService.prototype.getEnabledIntegrations = function () {
        var _this = this;
        return lodash_1.default.filter(this.getIntegrations(), function (integration) {
            return _this.isEnabled(integration.internalName);
        });
    };
    IntegrationService.prototype.openIntegrationSettings = function (integrationNameOrObject, options) {
        if (options == null) {
            options = {};
        }
        var integration = this.getIntegrationObject(integrationNameOrObject);
        if (integration == undefined) {
            return;
        }
        this.showIntegrationSettings(integration, options.updateRoute || false);
    };
    IntegrationService.prototype.getIntegrationSettingsUI = function (integrationNameOrObject) {
        var integration = this.getIntegrationObject(integrationNameOrObject);
        return this.integrationFocusCreator.create(integration);
    };
    IntegrationService.prototype.needsUpselling = function (integration) {
        var upsellFlag = (0, IntegrationToFeatureFlag_1.default)(integration.internalName);
        return upsellFlag != null && !this.usingFeature(upsellFlag);
    };
    IntegrationService.prototype.getAvailablePlans = function (integration) {
        return __awaiter(this, void 0, Promise, function () {
            var upsellFlag, plans, planName_1, idx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        upsellFlag = (0, IntegrationToFeatureFlag_1.default)(integration.internalName);
                        plans = (0, PlansOrder_1.default)();
                        if (!(upsellFlag == null)) return [3, 1];
                        return [2, plans];
                    case 1: return [4, this.upsellerService.getPlanNameForFeature(upsellFlag)];
                    case 2:
                        planName_1 = _a.sent();
                        idx = plans.findIndex(function (curr) {
                            return curr === planName_1;
                        });
                        return [2, plans.slice(idx)];
                }
            });
        });
    };
    IntegrationService.prototype.usingAccountingIntegration = function () {
        return this.isEnabled("xero") || this.isEnabled("quickbooks") || this.isEnabled("freshbooks");
    };
    IntegrationService.prototype.getEnabledAccountingIntegrations = function () {
        return lodash_1.default.filter(this.getEnabledIntegrations(), function (integration) {
            return lodash_1.default.includes(["xero", "quickbooks", "freshbooks"], integration.internalName);
        });
    };
    IntegrationService.prototype.getEnabledRelatedIntegrationNames = function (integrationName) {
        var e_1, _a, e_2, _b;
        var categories = this.getCategories(integrationName);
        var enabledRelatedIntegrations = {};
        try {
            for (var categories_1 = __values(categories), categories_1_1 = categories_1.next(); !categories_1_1.done; categories_1_1 = categories_1.next()) {
                var category = categories_1_1.value;
                var platforms = this.getIntegrationsInCategory(category);
                try {
                    for (var platforms_1 = (e_2 = void 0, __values(platforms)), platforms_1_1 = platforms_1.next(); !platforms_1_1.done; platforms_1_1 = platforms_1.next()) {
                        var platform = platforms_1_1.value;
                        if (platform.name !== integrationName) {
                            enabledRelatedIntegrations[platform.name] = true;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (platforms_1_1 && !platforms_1_1.done && (_b = platforms_1.return)) _b.call(platforms_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (categories_1_1 && !categories_1_1.done && (_a = categories_1.return)) _a.call(categories_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return Object.keys(enabledRelatedIntegrations);
    };
    IntegrationService.prototype.getIntegrationCategories = function () {
        return (Object.keys(Platforms_1.IntegrationCategory)
            .filter(function (categoryInternalName) {
            if (categoryInternalName !== "Zapier") {
                return categoryInternalName;
            }
        })
            .map(function (categoryInternalName) {
            return Platforms_1.IntegrationCategory[categoryInternalName];
        })
            .sort());
    };
    IntegrationService.prototype.getIntegrationsInCategory = function (categoryName) {
        var e_3, _a;
        var platformsInCategory = [];
        try {
            for (var _b = __values(this.integrationPlatforms), _c = _b.next(); !_c.done; _c = _b.next()) {
                var platform = _c.value;
                if (platform.categories.includes(categoryName)) {
                    platformsInCategory.push(platform);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return platformsInCategory;
    };
    IntegrationService.prototype.hasReachedCategoryLimit = function (integration) {
        var e_4, _a;
        var integrationName = integration.internalName;
        var categories = this.getCategories(integrationName);
        try {
            for (var categories_2 = __values(categories), categories_2_1 = categories_2.next(); !categories_2_1.done; categories_2_1 = categories_2.next()) {
                var category = categories_2_1.value;
                if (Object.keys(Platforms_1.categoryLimits).includes(category)) {
                    var limit = Platforms_1.categoryLimits[category];
                    if (limit != null && limit > 0) {
                        if (this.countEnabledIntegrationsForCategory(this.getIntegrationsInCategory(category)) >= limit) {
                            return true;
                        }
                    }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (categories_2_1 && !categories_2_1.done && (_a = categories_2.return)) _a.call(categories_2);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return false;
    };
    IntegrationService.prototype.getIntegration = function (name) {
        var e_5, _a;
        try {
            for (var _b = __values(this.integrationPlatforms), _c = _b.next(); !_c.done; _c = _b.next()) {
                var platform = _c.value;
                if (platform.internalName === name || platform.urlSafeName === name) {
                    return platform;
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        this.$log.error("Integration name doesn't exist");
    };
    IntegrationService.prototype.getIntegrationObject = function (integrationNameOrObject) {
        if (lodash_1.default.isString(integrationNameOrObject)) {
            return this.getIntegration(integrationNameOrObject);
        }
        else {
            return integrationNameOrObject;
        }
    };
    IntegrationService.prototype.showIntegrationSettings = function (integration, updateRoute) {
        if (updateRoute) {
            this.state.goToIntegrationSettings(integration);
        }
        else {
            var focus = this.integrationFocusCreator.create(integration);
            focus.show();
        }
    };
    IntegrationService.prototype.getCategories = function (integrationName) {
        var platform = this.getIntegration(integrationName);
        if (platform == undefined) {
            return [];
        }
        else {
            return platform.categories;
        }
    };
    IntegrationService.prototype.countEnabledIntegrationsForCategory = function (platforms) {
        var _this = this;
        return lodash_1.default.reduce(platforms, function (count, platform) {
            if (_this.isEnabled(platform.internalName)) {
                return count + 1;
            }
            else {
                return count;
            }
        }, 0);
    };
    return IntegrationService;
}());
exports.default = IntegrationService;
